import { isValidId } from './ids.js';

export const MOBILE_STALE_STORAGE_KEYS = ['cartState', 'hz_zone_id'];
export const WEB_STALE_STORAGE_KEYS = ['hz_zone_id', 'last_order'];
export const WEB_STALE_STORAGE_PREFIXES = ['user_cart_', 'device_cart_'];
export const WEB_AUTH_STORAGE_KEYS = ['auth_token', 'auth_username', 'auth_claims'];

export function shouldClearSessionForClaims(claims) {
  if (!claims || typeof claims !== 'object') return false;
  return claims.userId !== undefined && !isValidId(claims.userId);
}